// idRol tal como viene del token/backend: "1" = estudiante, "2" = administrador.
export const ROLES = {
  ESTUDIANTE: "1",
  ADMIN: "2",
};

export const getPrivateRouteByRole = (idRol) => {
  if (String(idRol) === ROLES.ESTUDIANTE) return "/profile";
  if (String(idRol) === ROLES.ADMIN) return "/course";
  return "/profile";
};

export const getUserId = (user) => user?.idUsuario ?? user?.id ?? null;

export const hasAceptadoTratamientoDatos = (user) => {
  if (!user) return false;
  const value = user.AutoTraDatos ?? user.autoTraDatos;
  return value === true || value === "true" || value === 1 || value === "1";
};
